import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import product from './modules/product.js'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		user,
		product,
	},

	state:{
		loading: false,
		elTop:0,
		showCred: null,
		editUser: false,
	},

	mutations:{
		changeLoadingStatus(state, payload){
			return state.loading = payload
		},
		updateScroll(state, payload){
			return state.elTop = payload
		},
		setCred(state, p){
			return state.showCred = p
		},
		setEditUser(state, p){
			return state.editUser = p
		}
	}

  //strict: true
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js